<div *ngIf="data" mat-dialog-content>
  <app-questions-form
    [data]="data"
    (closeModal)="onClose($event)"
  ></app-questions-form>
</div>
